var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playbooks-table container"},[_c('playbooks-filters'),(_vm.hasCards)?_c('playbooks-cards',{attrs:{"cards":_vm.cards}}):_c('div',{staticClass:"not-found"},[_vm._v("No Playbooks Found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }